export default function PHP_is_object() {
  return (
    <div>
      <h1>PHP_is_object</h1>
    </div>
  );
}
